import { SingleDatePicker, Select, Input } from 'components/Form'
import { getMessage } from 'lib/translator'
import React, { useState } from 'react'

const FilterNewSalesOrdersFilter = (props) => {
  const { onSubmit, onClear } = props
  const filterObj = Object.fromEntries(
    (new URLSearchParams(window.location.search).get('filter') || '')
      .split(';')
      .map((p) => p.split('='))
      .filter(([k, v]) => k && v)
      .map(([k, v]) => [k.split('.')[0], v])
  )
  const [orderId, setOrderId] = useState(filterObj?.base_sales_order ?? '')
  const [status, setStatus] = useState(filterObj?.state ?? '')
  const [redeliveryOrderId, setRedeliveryOrderId] = useState(
    filterObj?.order_no ?? ''
  )
  const [createTime, setCreateTime] = useState(filterObj?.create_time ?? '')

  const handleFilter = () => {
    const addIfNotEmpty = (obj, key, value) => {
      if (value) {
        obj[key] = value
      }
    }
    const searchVal = {}
    addIfNotEmpty(searchVal, 'base_sales_order.id', orderId)
    addIfNotEmpty(searchVal, 'state', status)
    addIfNotEmpty(searchVal, 'order_no', redeliveryOrderId)
    addIfNotEmpty(searchVal, 'create_time', createTime)
    onSubmit(searchVal)
  }

  const clearRedeliveryFilter = () => {
    setOrderId('')
    setRedeliveryOrderId('')
    setStatus('')
    setCreateTime()
    onClear()
  }

  const ORDER_STATUS = [
    { text: 'COMPLETED', value: 'COMPLETED' },
    { text: 'PENDING FULFILMENT', value: 'PENDING_FULFILMENT' },
    { text: 'PENDING SETTLEMENT', value: 'PENDING_SETTLEMENT' },
    { text: 'PENDING CANCELLATION', value: 'PENDING_CANCELLATION' },
    { text: 'CANCELLED', value: 'CANCELLED' },
  ]

  return (
    <div className="print-order-details">
      <div className="form-fields">
        <Input
          label={getMessage('redelivery.filter.sales.order.id')}
          value={orderId}
          placeholder={getMessage(
            'redelivery.filter.sales.order.id.placeholder'
          )}
          testid="order-id"
          type="text"
          onChange={(e) => setOrderId(e)}
        />
        <Input
          label={getMessage('redelivery.filter.redelivery.order.id')}
          value={redeliveryOrderId}
          placeholder={getMessage(
            'redelivery.filter.redelivery.order.id.placeholder'
          )}
          testid="order-id"
          type="text"
          onChange={(e) => setRedeliveryOrderId(e)}
        />
        <SingleDatePicker
          className="w-100"
          label={getMessage('redelivery.filter.redelivery.date')}
          placeholder={getMessage(
            'redelivery.filter.redelivery.date.placeholder'
          )}
          name="created-date"
          value={createTime}
          isOutsideRange
          onChange={(e) => setCreateTime(e)}
        />
        <Select
          name="select-status"
          placeholder={getMessage(
            'redelivery.filter.redelivery.select.placeholder'
          )}
          label={getMessage('redelivery.filter.redelivery.status')}
          options={ORDER_STATUS}
          value={status}
          testid="status"
          type="text"
          onChange={(e) => setStatus(e)}
        />
      </div>
      <div className="row">
        <div className="form-actions">
          <button
            type="button"
            disabled={!orderId && !redeliveryOrderId && !createTime && !status}
            className="primary search-redelivery-order"
            data-testid="search-redelivery-order"
            onClick={handleFilter}
          >
            {getMessage('redelivery.filter.redelivery.search')}
          </button>
          <button
            type="button"
            className="button"
            data-testid="clear-redelivery-order"
            onClick={clearRedeliveryFilter}
          >
            {getMessage('redelivery.filter.redelivery.clear.all')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default FilterNewSalesOrdersFilter
